import styled from 'styled-components';
import UnderlineSelected from '../UI/UnderlineSelected';
import { fontFamilies } from '../UI/Font';

const DepartmentText = styled(UnderlineSelected)`
  font-size: ${({ fontSize }) => fontSize || '15px'};
  font-family: ${({ active }) => (active ? fontFamilies.bold : fontFamilies.light)};
  ${({ underline, active }) =>
    underline && active
      ? `
    border-bottom: 3px solid #000;
    display: block;
  }`
      : null}
  &:hover {
    font-family: ${fontFamilies.bold};
  }
  &::after {
    font-family: ${fontFamilies.bold};
    display: block;
    content: attr(title);
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

export default DepartmentText;
